/* eslint @typescript-eslint/strict-boolean-expressions: off */

import styles from "./styles/Label.module.css";

type NativeProps = React.LabelHTMLAttributes<HTMLLabelElement>;

export const Label: React.FC<NativeProps> = (props) => {
  const { ...nativeProps } = props;

  return (
    <label className={styles.label} {...nativeProps}>
      {props.children}
    </label>
  );
};
